import React, { useEffect, useState } from "react";
// import { products as defaultProducts } from "../data/products";
import * as XLSX from "xlsx";
import { HiOutlineCube, HiOutlineQrcode, HiOutlineTag, HiOutlineTrash, HiOutlineDocumentText, HiOutlineEye, HiOutlinePlus, HiOutlineCalendar, HiOutlineClipboardList, HiOutlineCheck, HiOutlineX, HiOutlineEyeOff, HiOutlineCurrencyDollar, HiOutlineBookOpen, HiOutlineRefresh, HiOutlineSearch, HiOutlineCog, HiOutlineDownload, HiOutlineChevronDown, HiOutlinePhotograph } from 'react-icons/hi';
import { Link } from 'react-router-dom'; // Added Link import
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// jsPDF'e autoTable plugin'ini ekle
jsPDF.API.autoTable = autoTable;

const emptyProduct = {
  code: "",
  dmoKodu: "",
  name: "",
  barcode: "",
  lot: "",
  stock: "",
  price: "",
  uretimTarihi: "",
  skt: ""
};

const EXCHANGE_RATE = 40;

function getProductUDIs(product) {
  const offers = JSON.parse(localStorage.getItem('offers') || '[]');
  const udis = [];
  offers.forEach(offer => {
    (offer.items || []).forEach(item => {
      // code veya barcode ile eşleşen satırları bul
      const codes = Array.isArray(item.code) ? item.code : [item.code];
      if (
        (codes && Array.isArray(codes) && codes.includes(product.code)) ||
        (item.barcode && product.barcode && item.barcode === product.barcode)
      ) {
        udis.push({
          udi: item.udi,
          offerNo: offer.offerNo || offer.id,
          date: offer.date
        });
      }
    });
  });
  return udis;
}

export default function UrunListesiPage() {
  const [urunler, setUrunler] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [newProduct, setNewProduct] = useState(emptyProduct);
  const [showDetail, setShowDetail] = useState(false);
  const [detailProduct, setDetailProduct] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importStep, setImportStep] = useState(0); // 0: dosya seç, 1: yükleniyor, 2: sonuç
  const [importMessage, setImportMessage] = useState("");
  const [importError, setImportError] = useState("");
  const [importFile, setImportFile] = useState(null);
  const [importProgress, setImportProgress] = useState(0);
  const [previewData, setPreviewData] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [columnMapping, setColumnMapping] = useState({});
  const [availableFields, setAvailableFields] = useState([]);
  const [excelColumns, setExcelColumns] = useState([]);
  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const [detailTab, setDetailTab] = useState('general');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showPrices, setShowPrices] = useState(false); // Fiyatları göster/gizle
  const [updatingPrices, setUpdatingPrices] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); // Arama terimi
  const [uploadingImage, setUploadingImage] = useState(false); // Resim yükleme durumu
  const [editingTags, setEditingTags] = useState(''); // Etiket düzenleme
  const [tagSuggestions, setTagSuggestions] = useState([]); // Etiket önerileri
  const [showTagWizard, setShowTagWizard] = useState(false); // Etiket sihirbazı
  const [sutDetails, setSutDetails] = useState([]); // SUT kod detayları
  const [selectedSutCode, setSelectedSutCode] = useState(null); // Seçili SUT kodu
  const [showMediaLibrary, setShowMediaLibrary] = useState(false); // Medya kütüphanesi modalı
  const [mediaFiles, setMediaFiles] = useState([]); // Medya dosyaları
  const [mediaLoading, setMediaLoading] = useState(false); // Medya yükleme durumu
  const [mediaSearch, setMediaSearch] = useState(''); // Medya arama
  const [autoTagging, setAutoTagging] = useState(false); // Otomatik etiketleme durumu
  const [showEditModal, setShowEditModal] = useState(false); // Düzenleme modalı
  const [editingProduct, setEditingProduct] = useState(null); // Düzenlenen ürün
  const [editForm, setEditForm] = useState({}); // Düzenleme formu

    // Etiket önerisi alma fonksiyonu
  const handleGetTagSuggestions = async (productName, kategori) => {
    try {
      const response = await fetch('/api/products/suggest-tags', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productName, kategori })
      });

      if (response.ok) {
        const result = await response.json();
        setTagSuggestions(result.suggestions);
        return result.suggestions;
      } else {
        console.error('Etiket önerisi alınamadı');
        return [];
      }
    } catch (error) {
      console.error('Etiket önerisi hatası:', error);
      return [];
    }
  };

  // Etiket önerisini uygulama
  const handleApplyTagSuggestions = (productId) => {
    if (tagSuggestions.length > 0) {
      const suggestedTags = tagSuggestions.join(', ');
      setEditingTags(suggestedTags);
      handleUpdateTags(productId, suggestedTags);
      setTagSuggestions([]);
    }
  };

  // Tüm ürünlere otomatik etiket ekleme
  const handleAutoTagAll = async () => {
    if (!window.confirm('Tüm ürünlere otomatik etiket eklemek istediğinize emin misiniz?')) return;
    
    setAutoTagging(true);
    try {
      const response = await fetch('/api/products/auto-tag-all', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.ok) {
        const result = await response.json();
        alert(result.message);
        // Ürün listesini yenile
        fetch('/api/products')
          .then(res => res.json())
          .then(data => setUrunler(data));
      } else {
        alert('Otomatik etiket ekleme başarısız!');
      }
    } catch (error) {
      console.error('Otomatik etiket ekleme hatası:', error);
      alert('Otomatik etiket ekleme başarısız!');
    } finally {
      setAutoTagging(false);
    }
  };

  // Etiket güncelleme fonksiyonu
  const handleUpdateTags = async (productId, tags) => {
    try {
      const response = await fetch(`/api/products/${productId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tags })
      });

      if (response.ok) {
        // Ürünü güncelle
        const updatedProducts = urunler.map(product => {
          if (product.id === productId) {
            return { ...product, tags };
          }
          return product;
        });
        setUrunler(updatedProducts);

        // Detail product'ı da güncelle
        if (detailProduct && detailProduct.id === productId) {
          setDetailProduct({ ...detailProduct, tags });
        }

        alert('Etiketler başarıyla güncellendi!');
      } else {
        alert('Etiketler güncellenirken hata oluştu!');
      }
    } catch (error) {
      console.error('Etiket güncelleme hatası:', error);
      alert('Etiketler güncellenirken hata oluştu!');
    }
  };

  // Medya kütüphanesini aç
  const openMediaLibrary = async () => {
    setShowMediaLibrary(true);
    setMediaLoading(true);
    setMediaSearch('');
    try {
      const res = await fetch('/api/media-library');
      if (res.ok) {
        const data = await res.json();
        setMediaFiles(data);
      }
    } catch (err) {
      console.error('Medya kütüphanesi yüklenemedi:', err);
    } finally {
      setMediaLoading(false);
    }
  };

  // Medya kütüphanesinden resim seç
  const handleSelectFromLibrary = async (imageUrl) => {
    if (!detailProduct) return;
    try {
      const response = await fetch(`/api/products/${detailProduct.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_url: imageUrl })
      });
      if (response.ok) {
        const updatedProducts = urunler.map(p =>
          p.id === detailProduct.id ? { ...p, image_url: imageUrl } : p
        );
        setUrunler(updatedProducts);
        setDetailProduct({ ...detailProduct, image_url: imageUrl });
        setShowMediaLibrary(false);
        alert('Resim başarıyla atandı!');
      } else {
        alert('Resim atanamadı!');
      }
    } catch (err) {
      console.error('Resim atama hatası:', err);
      alert('Resim atanırken hata oluştu!');
    }
  };

  // Resim yükleme fonksiyonu
  const handleImageUpload = async (file, productId) => {
    if (!file) return;
    
    console.log('Resim yükleme başlatıldı:', file.name, 'Product ID:', productId);
    setUploadingImage(true);
    const formData = new FormData();
    formData.append('image', file);
    
    try {
      console.log('Backend\'e resim yükleme isteği gönderiliyor...');
      const response = await fetch('/api/upload-image', {
        method: 'POST',
        body: formData
      });
      
      console.log('Backend yanıtı:', response.status, response.statusText);
      
      if (response.ok) {
        const result = await response.json();
        console.log('Resim yükleme sonucu:', result);
        
        // Ürünü güncelle
        const updatedProducts = urunler.map(product => {
          if (product.id === productId) {
            return { ...product, image_url: result.url };
          }
          return product;
        });
        setUrunler(updatedProducts);
        
        // Detail product'ı da güncelle
        if (detailProduct && detailProduct.id === productId) {
          setDetailProduct({ ...detailProduct, image_url: result.url });
        }
        
        console.log('Backend\'de ürün güncelleniyor...');
        // Backend'de ürünü güncelle
        const productToUpdate = urunler.find(p => p.id === productId);
        const updateResponse = await fetch(`/api/products/${productId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            image_url: result.url
          })
        });
        
        console.log('Ürün güncelleme yanıtı:', updateResponse.status);
        
        if (updateResponse.ok) {
          console.log('Resim yükleme işlemi tamamlandı!');
          // Detail product'ı da güncelle
          if (detailProduct && detailProduct.id === productId) {
            setDetailProduct({ ...detailProduct, image_url: result.url });
          }
          // Başarı mesajı göster
          setTimeout(() => {
            alert('Resim başarıyla yüklendi!');
          }, 100);
        } else {
          console.error('Ürün güncelleme hatası');
          const errorText = await updateResponse.text();
          console.error('Ürün güncelleme hatası detayı:', errorText);
          alert('Resim yüklendi ama ürün güncellenemedi!');
        }
      } else {
        const errorText = await response.text();
        console.error('Resim yükleme hatası:', errorText);
        alert('Resim yüklenirken hata oluştu!');
      }
    } catch (error) {
      console.error('Resim yükleme hatası:', error);
      alert('Resim yüklenirken hata oluştu!');
    } finally {
      setUploadingImage(false);
    }
  };

  // Ürünleri backend'den çek
  useEffect(() => {
    fetch('/api/products')
      .then(res => res.json())
      .then(data => setUrunler(data))
      .catch(() => setUrunler([]));
  }, []);

  // Dropdown dışına tıklandığında kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showExportDropdown && !event.target.closest('.export-dropdown')) {
        setShowExportDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showExportDropdown]);

  // Ürün ekle (backend'e POST)
  const handleAdd = async () => {
    if (!newProduct.code || !newProduct.name || !newProduct.price) return;
    try {
      const resp = await fetch('/api/products', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newProduct)
      });
      if (!resp.ok) throw new Error('Ürün eklenemedi');
      setNewProduct(emptyProduct);
      setShowAdd(false);
      // Listeyi güncelle
      fetch('/api/products')
        .then(res => res.json())
        .then(data => setUrunler(data));
    } catch (err) {
      alert('Ürün eklenemedi: ' + err.message);
    }
  };

  // Ürün sil (backend'e DELETE)
  const handleDelete = async (id) => {
    if (!window.confirm('Bu ürünü silmek istediğinize emin misiniz?')) return;
    try {
      const resp = await fetch(`/api/products/${id}`, { method: 'DELETE' });
      if (!resp.ok) throw new Error('Ürün silinemedi');
      // Listeyi güncelle
      fetch('/api/products')
        .then(res => res.json())
        .then(data => setUrunler(data));
    } catch (err) {
      alert('Ürün silinemedi: ' + err.message);
    }
  };

  // Seçili ürünleri sil
  const handleBulkDelete = async () => {
    if (selectedProducts.length === 0) return;
    if (!window.confirm(`${selectedProducts.length} ürünü silmek istediğinize emin misiniz?`)) return;
    try {
      const resp = await fetch('/api/products/bulk', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids: selectedProducts })
      });
      if (!resp.ok) throw new Error('Ürünler silinemedi');
      const result = await resp.json();
      alert(result.message);
      setSelectedProducts([]);
      setSelectAll(false);
      // Listeyi güncelle
      fetch('/api/products')
        .then(res => res.json())
        .then(data => setUrunler(data));
    } catch (err) {
      alert('Ürünler silinemedi: ' + err.message);
    }
  };

  // Tek ürün seç/kaldır
  const handleSelectProduct = (id) => {
    setSelectedProducts(prev => 
      prev && prev.includes(id) 
        ? prev.filter(p => p !== id)
        : [...(prev || []), id]
    );
  };

  // Tümünü seç/kaldır
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedProducts([]);
      setSelectAll(false);
    } else {
      setSelectedProducts(urunler.map(u => u.id));
      setSelectAll(true);
    }
  };

  // Detay modalı aç
  const handleShowDetail = async (urun) => {
    setDetailProduct(urun);
    setShowDetail(true);
    setDetailTab('general');
    setSutDetails([]);
    setSelectedSutCode(null);
    
    // SUT kodları varsa detaylarını çek
    if (urun.sut_codes) {
      try {
        const codes = urun.sut_codes.split(',').map(c => c.trim()).filter(Boolean);
        if (codes.length > 0) {
          const resp = await fetch('/api/sut-details', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sut_codes: codes })
          });
          if (resp.ok) {
            const data = await resp.json();
            setSutDetails(data);
            if (data.length > 0) setSelectedSutCode(data[0].sut_code);
          }
        }
      } catch (e) {
        console.error('SUT detay çekme hatası:', e);
      }
    }
  };

  // Düzenleme modalı aç
  const handleEditProduct = (urun) => {
    setEditingProduct(urun);
    setEditForm({
      name: urun.name || '',
      code: urun.code || '',
      dmoKodu: urun.dmoKodu || '',
      barcode: urun.barcode || '',
      lot: urun.lot || '',
      stock: urun.stock || '',
      price: urun.price || '',
      uretimTarihi: urun.uretimTarihi || '',
      skt: urun.skt || '',
      tags: urun.tags || '',
      description: urun.description || '',
      kategori: urun.kategori || ''
    });
    setShowEditModal(true);
  };

  // Düzenleme formunu kaydet
  const handleSaveEdit = async () => {
    try {
      const response = await fetch(`/api/products/${editingProduct.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editForm)
      });

      if (response.ok) {
        // Ürün listesini güncelle
        const updatedProducts = urunler.map(product => {
          if (product.id === editingProduct.id) {
            return { ...product, ...editForm };
          }
          return product;
        });
        setUrunler(updatedProducts);
        
        // Detay modalında da güncelle
        if (detailProduct && detailProduct.id === editingProduct.id) {
          setDetailProduct({ ...detailProduct, ...editForm });
        }
        
        setShowEditModal(false);
        setEditingProduct(null);
        setEditForm({});
        alert('Ürün başarıyla güncellendi!');
      } else {
        alert('Ürün güncellenirken hata oluştu!');
      }
    } catch (error) {
      console.error('Ürün güncelleme hatası:', error);
      alert('Ürün güncellenirken hata oluştu!');
    }
  };

  // Fiyatları göster/gizle toggle
  const togglePrices = () => {
    setShowPrices(!showPrices);
  };

  // Arama fonksiyonu
  const filteredProducts = urunler.filter(product => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      (product.code && product.code.toLowerCase().includes(term)) ||
      (product.name && product.name.toLowerCase().includes(term)) ||
      (product.barcode && product.barcode.toLowerCase().includes(term)) ||
      (product.dmoKodu && product.dmoKodu.toLowerCase().includes(term))
    );
  });

  // SUT kodunu renklendirme fonksiyonu
  const renderSUTCode = (code, sourceFile) => {
    const HiOutlineBookOpen = require('react-icons/hi').HiOutlineBookOpen;
    if (!sourceFile) {
      return <span className="text-gray-700">{code}</span>;
    }
    
    // Virgül ile ayrılmış kodları kontrol et
    if (code && code.includes(',')) {
      const codes = code.split(',').map(c => c.trim());
      return (
        <span className="text-blue-600 font-bold flex items-center gap-1">
          {codes.map((c, index) => (
            <span key={index}>{c}{index < codes.length - 1 && <span className="text-gray-500">, </span>}</span>
          ))}
          <HiOutlineBookOpen className="inline-block w-4 h-4 text-blue-500 ml-1" title="SUT Kütüphanesinde" />
        </span>
      );
    }
    
    return (
      <span className="text-blue-600 font-bold flex items-center gap-1">
        {code}
        <HiOutlineBookOpen className="inline-block w-4 h-4 text-blue-500 ml-1" title="SUT Kütüphanesinde" />
      </span>
    );
  };

  const handleImportFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    setImportFile(selectedFile);
    setImportError("");
    
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = async (evt) => {
        try {
          const data = new Uint8Array(evt.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(sheet);
          setPreviewData(rows.slice(0, 10)); // İlk 10 satırı önizleme için
          setShowPreview(true);
          
          // Excel kolonlarını al
          if (rows.length > 0) {
            setExcelColumns(Object.keys(rows[0]));
          }
          
          // Mevcut alanları getir
          try {
            console.log('Fetching fields from API...');
            const response = await fetch('/api/products/fields');
            console.log('Response status:', response.status);
            const result = await response.json();
            console.log('Fields result:', result);
            setAvailableFields(result.fields || []);
          } catch (error) {
            console.error('Alanlar getirilemedi:', error);
          }
        } catch (error) {
          console.error('Excel okuma hatası:', error);
          setPreviewData(null);
          setShowPreview(false);
        }
      };
      reader.readAsArrayBuffer(selectedFile);
    } else {
      setPreviewData(null);
      setShowPreview(false);
    }
  };

  const handleImportStart = () => {
    if (!importFile) return;
    
    // Kolon eşleştirme kontrolü (sadece SUT Kodu zorunlu)
    const requiredFields = ['code'];
    const missingFields = requiredFields.filter(field => !columnMapping[field]);
    
    if (missingFields.length > 0) {
      setShowColumnMapping(true);
      return;
    }
    
    setImportStep(1);
    setImportMessage("");
    setImportError("");
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const products = XLSX.utils.sheet_to_json(sheet);
        const resp = await fetch('/api/products/import', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ products, columnMapping })
        });
        const result = await resp.json();
        console.log('Import response:', result);
        if (!result.success) throw new Error(result.error || 'Toplu yükleme başarısız');
        setImportResult(result);
        setImportMessage(`İşlem tamamlandı: ${result.inserted || 0} yeni, ${result.updated || 0} güncelleme`);
        setImportStep(2);
        // Listeyi güncelle
        fetch('/api/products')
          .then(res => res.json())
          .then(data => setUrunler(data));
      } catch (err) {
        setImportError('Dosya okunamadı veya yükleme hatalı: ' + err.message);
        setImportStep(0);
      }
    };
    if (importFile.name.endsWith('.xlsx') || importFile.name.endsWith('.xls')) {
      reader.readAsArrayBuffer(importFile);
    } else {
      reader.readAsText(importFile);
    }
  };

  // SUT kütüphanesinden fiyat güncelle
  const updatePricesFromSut = async () => {
    setUpdatingPrices(true);
    try {
      const response = await fetch('/api/products/update-prices-from-sut', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (response.ok) {
        const result = await response.json();
        alert(`${result.message}\n\nGüncellenen: ${result.updated}\nBulunamayan: ${result.notFound}`);
        fetch('/api/products') // Ürün listesini yenile
          .then(res => res.json())
          .then(data => setUrunler(data));
      } else {
        const error = await response.json();
        alert(`Hata: ${error.error}`);
      }
    } catch (error) {
      alert(`Güncelleme hatası: ${error.message}`);
    } finally {
      setUpdatingPrices(false);
    }
  };

  // Dışa aktarma fonksiyonları
  const exportToExcel = () => {
    const exportData = filteredProducts.map(product => ({
      'SUT Kodu': product.code || '',
      'Ürün Adı': product.name || '',
      'Fiyat (TL)': product.price || '',
      'İhracat Fiyatı ($)': product.price ? (Number(product.price) / 40).toFixed(2) : '',
      'SUT Kütüphanesi': product.source_file ? 'Mevcut' : 'Yok',
      'Proforma Sayısı': product.proformaCount || 0,
      'Satış Sayısı': product.satisCount || 0,
      'Üretim Sayısı': product.uretimCount || 0,
      'Stok Kodu': product.stock_code || '',
      'Barkod': product.barcode || '',
      'DMO Kodu': product.dmoKodu || '',
      'Kategori': product.kategori || '',
      'Marka': product.marka || '',
      'Eklenme Tarihi': product.eklenmeTarihi || ''
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Ürünler');
    
    const fileName = `urun_listesi_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    setShowExportDropdown(false);
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    
    // Türkçe karakter desteği için font ayarları
    doc.setFont('helvetica');
    doc.setLanguage('tr');
    
    // Başlık
    doc.setFontSize(18);
    doc.text('Ürün Listesi', 14, 22);
    doc.setFontSize(10);
    doc.text(`Oluşturulma Tarihi: ${new Date().toLocaleDateString('tr-TR')}`, 14, 30);
    doc.text(`Toplam Ürün: ${filteredProducts.length}`, 14, 37);

    // Tablo verileri - Türkçe karakterleri düzgün göster
    const tableData = filteredProducts.map(product => [
      product.code || '',
      product.name || '',
      product.price ? `${product.price} ₺` : '',
      product.price ? `${(Number(product.price) / 40).toFixed(2)} $` : '',
      product.source_file ? '✓' : '✗',
      `${product.proformaCount || 0} / ${product.satisCount || 0} / ${product.uretimCount || 0}`
    ]);

    autoTable(doc, {
      startY: 45,
      head: [['SUT Kodu', 'Ürün Adı', 'Fiyat (TL)', 'İhracat ($)', 'SUT Kütüphanesi', 'Pro/Sat/Üret']],
      body: tableData,
      theme: 'grid',
      headStyles: { 
        fillColor: [59, 130, 246],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      styles: { 
        fontSize: 8,
        cellPadding: 4,
        font: 'helvetica'
      },
      columnStyles: {
        0: { cellWidth: 28, fontStyle: 'bold' },
        1: { cellWidth: 55 },
        2: { cellWidth: 22, halign: 'right' },
        3: { cellWidth: 22, halign: 'right' },
        4: { cellWidth: 22, halign: 'center' },
        5: { cellWidth: 25, halign: 'center' }
      },
      margin: { top: 45, right: 10, bottom: 10, left: 10 },
      pageBreak: 'auto'
    });

    const fileName = `urun_listesi_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);
    setShowExportDropdown(false);
  };

  // Yeni Excel export fonksiyonları
  const exportToExcelWithImages = async () => {
    try {
      alert('Resimli export başlatılıyor... Bu işlem biraz zaman alabilir.');
      const kategori = searchTerm || '';
      const response = await fetch(`/api/products/export-excel?kategori=${encodeURIComponent(kategori)}&includeImages=true`);
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `urunler_excel_resimli_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        const error = await response.json();
        alert('Excel export hatası: ' + error.error);
      }
    } catch (error) {
      console.error('Excel export hatası:', error);
      alert('Excel export hatası: ' + error.message);
    }
    setShowExportDropdown(false);
  };

  const exportToExcelWithoutImages = async () => {
    try {
      alert('Hızlı export başlatılıyor...');
      const kategori = searchTerm || '';
      const response = await fetch(`/api/products/export-excel?kategori=${encodeURIComponent(kategori)}&includeImages=false`);
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `urunler_excel_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        const error = await response.json();
        alert('Excel export hatası: ' + error.error);
      }
    } catch (error) {
      console.error('Excel export hatası:', error);
      alert('Excel export hatası: ' + error.message);
    }
    setShowExportDropdown(false);
  };

  const exportImagesAsZip = async () => {
    try {
      const kategori = searchTerm || '';
      const response = await fetch(`/api/products/export-images?kategori=${encodeURIComponent(kategori)}`);
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `urun_resimleri_${new Date().toISOString().split('T')[0]}.zip`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        const error = await response.json();
        alert('Resim export hatası: ' + error.error);
      }
    } catch (error) {
      console.error('Resim export hatası:', error);
      alert('Resim export hatası: ' + error.message);
    }
    setShowExportDropdown(false);
  };

  return (
    <div className="w-full p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <h1 className="text-2xl font-bold text-blue-900 flex items-center gap-2">
            <HiOutlineCube className="w-6 h-6" />
            Ürün Listesi
          </h1>
          <span className="text-sm text-gray-500">({filteredProducts.length} ürün)</span>
        </div>
        
        <div className="flex items-center gap-3">
          {/* Dışa Aktarma Dropdown */}
          <div className="relative export-dropdown">
            <button
              onClick={() => setShowExportDropdown(!showExportDropdown)}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              <HiOutlineDownload className="w-4 h-4" />
              Dışa Aktar
              <HiOutlineChevronDown className="w-4 h-4" />
            </button>
            
            {showExportDropdown && (
              <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 min-w-56">
                <div className="px-3 py-2 text-xs font-semibold text-gray-500 border-b border-gray-100">
                  Excel Export Seçenekleri
                </div>
                <button
                  onClick={exportToExcelWithImages}
                  className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <HiOutlineDocumentText className="w-4 h-4 text-green-600" />
                  Excel + Resimler (.xlsx) - Yavaş olabilir (max 50 resim)
                </button>
                <button
                  onClick={exportToExcelWithoutImages}
                  className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <HiOutlineDocumentText className="w-4 h-4 text-blue-600" />
                  Excel Sadece Veri (.xlsx) - Hızlı Export
                </button>
                <div className="px-3 py-2 text-xs font-semibold text-gray-500 border-b border-gray-100">
                  Diğer Formatlar
                </div>
                <button
                  onClick={exportToExcel}
                  className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <HiOutlineDocumentText className="w-4 h-4 text-orange-600" />
                  Basit Excel (.xlsx)
                </button>
                <button
                  onClick={exportToPDF}
                  className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <HiOutlineDocumentText className="w-4 h-4 text-red-600" />
                  PDF (.pdf)
                </button>
                <div className="px-3 py-2 text-xs font-semibold text-gray-500 border-b border-gray-100">
                  Resim Export
                </div>
                <button
                  onClick={exportImagesAsZip}
                  className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <HiOutlinePhotograph className="w-4 h-4 text-purple-600" />
                  Resimler ZIP (.zip) - Sadece resim dosyaları
                </button>
              </div>
            )}
          </div>

          <Link
            to="/sut-fiyatlari"
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            <HiOutlineCurrencyDollar className="h-4 w-4" />
            SUT Fiyatları
          </Link>

          <button
            onClick={updatePricesFromSut}
            disabled={updatingPrices}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
          >
            <HiOutlineRefresh className={`h-4 w-4 ${updatingPrices ? 'animate-spin' : ''}`} />
            {updatingPrices ? 'Güncelleniyor...' : 'SUT Kütüphanesinden Güncelle'}
          </button>

          <button
            onClick={() => setShowAdd(v => !v)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <HiOutlinePlus className="w-4 h-4" />
            Yeni Ürün Ekle
          </button>
        </div>
      </div>
      <div className="bg-white rounded-2xl shadow-xl p-8 flex flex-col gap-6 border border-blue-100 mt-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex flex-col">
            <span className="font-semibold text-blue-800 text-lg">Tanımlı Ürünler</span>
            {searchTerm && (
              <span className="text-sm text-gray-600">
                {filteredProducts.length} ürün bulundu (toplam {urunler.length} ürün)
              </span>
            )}
          </div>
          <div className="flex gap-2 items-center">
            <div className="relative">
              <input
                type="text"
                placeholder="SUT Kodu, Ürün Adı, Barkod ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="px-4 py-2 pl-10 rounded-lg border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-80"
              />
              <HiOutlineSearch className="absolute left-3 top-2.5 h-5 w-5 text-blue-400" />
            </div>
            {selectedProducts.length > 0 && (
              <button
                className="px-4 py-2 rounded bg-red-600 text-white font-semibold hover:bg-red-700 transition text-sm flex items-center gap-2"
                onClick={handleBulkDelete}
              >
                <HiOutlineTrash className="w-5 h-5" /> Seçili Ürünleri Sil ({selectedProducts.length})
              </button>
            )}
            <button
              onClick={handleAutoTagAll}
              disabled={autoTagging}
              className={`px-4 py-2 rounded text-sm font-medium flex items-center gap-2 transition ${
                autoTagging 
                  ? 'bg-gray-400 text-white cursor-not-allowed' 
                  : 'bg-purple-600 text-white hover:bg-purple-700'
              }`}
            >
              {autoTagging ? '🔄 Etiketleniyor...' : '🪄 Otomatik Etiket Ekle'}
            </button>
            <button
              className="px-4 py-2 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700 transition text-sm flex items-center gap-2"
              onClick={() => setShowAdd(v => !v)}
            >
              <HiOutlinePlus className="w-5 h-5" /> Ürün Ekle
            </button>
            <button
              className="px-4 py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 transition text-sm flex items-center gap-2"
              onClick={() => setShowImportModal(true)}
            >
              <HiOutlineDocumentText className="w-5 h-5" /> Toplu Yükle
            </button>
          </div>
        </div>
        {showAdd && (
          <div className="flex flex-col sm:flex-row flex-wrap gap-2 mb-4 items-center bg-blue-50 rounded-xl p-4">
            <input type="text" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-28" placeholder="SUT Kodu" value={newProduct.code} onChange={e => setNewProduct(p => ({ ...p, code: e.target.value }))} maxLength={20} />
            <input type="text" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-28" placeholder="DMO Kodu" value={newProduct.dmoKodu} onChange={e => setNewProduct(p => ({ ...p, dmoKodu: e.target.value }))} maxLength={20} />
            <input type="text" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-40" placeholder="Ürün Adı" value={newProduct.name} onChange={e => setNewProduct(p => ({ ...p, name: e.target.value }))} maxLength={60} />
            <input type="text" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-32" placeholder="Barkod" value={newProduct.barcode} onChange={e => setNewProduct(p => ({ ...p, barcode: e.target.value }))} maxLength={30} />
            <input type="text" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-24" placeholder="Lot" value={newProduct.lot} onChange={e => setNewProduct(p => ({ ...p, lot: e.target.value }))} maxLength={20} />
            <input type="text" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-24" placeholder="Stok" value={newProduct.stock} onChange={e => setNewProduct(p => ({ ...p, stock: e.target.value }))} maxLength={20} />
            <input type="number" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-28" placeholder="Birim Fiyatı" value={newProduct.price} onChange={e => {
              const price = e.target.value;
              setNewProduct(p => ({ ...p, price, export_price: price ? (parseFloat(price) / EXCHANGE_RATE).toFixed(2) : '' }));
            }} min={0} />
            <input type="number" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-28" placeholder="İhracat Fiyatı ($)" value={newProduct.export_price || ''} onChange={e => setNewProduct(p => ({ ...p, export_price: e.target.value }))} min={0} />
            <input type="date" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-36" placeholder="Üretim Tarihi" value={newProduct.uretimTarihi} onChange={e => setNewProduct(p => ({ ...p, uretimTarihi: e.target.value }))} />
            <input type="text" className="px-3 py-2 rounded border border-blue-200 focus:ring-2 focus:ring-blue-200 text-blue-900 bg-blue-50 w-36" placeholder="Promosyon" value={newProduct.skt} onChange={e => setNewProduct(p => ({ ...p, skt: e.target.value }))} />
            <button className="px-4 py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 transition text-sm" onClick={handleAdd}>Kaydet</button>
            <button className="px-4 py-2 rounded bg-gray-200 text-blue-900 font-semibold hover:bg-gray-300 transition text-sm" onClick={() => setShowAdd(false)}>İptal</button>
          </div>
        )}
        <div className="overflow-x-auto rounded-xl border border-blue-100">
          <table className="min-w-full text-sm">
            <thead className="bg-blue-50">
              <tr className="text-blue-900">
                <th className="px-3 py-2 text-left">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                  />
                </th>
                <th className="px-3 py-2 text-left">Resim</th>
                <th className="px-3 py-2 text-left">SUT Kodu</th>
                <th className="px-3 py-2 text-left">Ürün</th>
                <th className="px-3 py-2 text-left">Etiketler</th>
                <th className="px-3 py-2 text-center">Süreç Takibi</th>
                <th className="px-3 py-2 text-left">Fiyat</th>
                <th className="px-3 py-2 text-left text-blue-700 font-bold">İhracat Fiyatı</th>
                <th className="px-3 py-2 text-left">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 && (
                <tr><td colSpan={12} className="text-center text-gray-400 py-6">
                  {searchTerm ? `"${searchTerm}" için sonuç bulunamadı.` : 'Hiç ürün yok.'}
                </td></tr>
              )}
              {filteredProducts.map(u => (
                <tr key={u.id} className="hover:bg-blue-50 transition">
                  <td className="px-3 py-2">
                    <input
                      type="checkbox"
                      checked={selectedProducts && selectedProducts.includes(u.id)}
                      onChange={() => handleSelectProduct(u.id)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                  </td>
                  <td className="px-3 py-2">
                    {u.image_url ? (
                      <img 
                        src={u.image_url} 
                        alt={u.name}
                        className="w-12 h-12 object-cover rounded border border-gray-200 cursor-pointer hover:opacity-80 transition"
                        onClick={() => handleShowDetail(u)}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : (
                      <div className="w-12 h-12 bg-gray-100 rounded border border-gray-200 flex items-center justify-center cursor-pointer hover:bg-gray-200 transition" onClick={() => handleShowDetail(u)}>
                        <HiOutlineCube className="w-5 h-5 text-gray-400" />
                      </div>
                    )}
                    {u.image_url && (
                      <div className="hidden w-12 h-12 bg-gray-100 rounded border border-gray-200 items-center justify-center">
                        <HiOutlineCube className="w-5 h-5 text-gray-400" />
                      </div>
                    )}
                  </td>
                  <td className="px-3 py-2 font-mono text-xs">
                    {renderSUTCode(u.code, u.source_file)}
                  </td>
                  <td className="px-3 py-2">
                    <span className="font-bold text-blue-900">{u.name}</span>
                  </td>
                  <td className="px-3 py-2">
                    {u.tags ? (
                      <div className="flex flex-wrap gap-1">
                        {u.tags.split(',').slice(0, 3).map((tag, index) => (
                          <span
                            key={index}
                            className="bg-blue-100 text-blue-800 px-1 py-0.5 rounded text-xs"
                            title={u.tags}
                          >
                            {tag.trim()}
                          </span>
                        ))}
                        {u.tags.split(',').length > 3 && (
                          <span className="text-xs text-gray-500">
                            +{u.tags.split(',').length - 3}
                          </span>
                        )}
                      </div>
                    ) : (
                      <span className="text-gray-400 text-xs">-</span>
                    )}
                  </td>
                  {/* Süreç Takibi - Tüm ikonları tek kolonda göster */}
                  <td className="px-3 py-2 text-center">
                    <div className="flex justify-center items-center gap-3">
                      {/* Proforma */}
                      <div className="flex flex-col items-center">
                        <HiOutlineClipboardList className="w-4 h-4 text-blue-400" />
                        <span className="text-xs text-blue-900 font-semibold">{u.proformaCount || 0}</span>
                      </div>
                      {/* Satış */}
                      <div className="flex flex-col items-center">
                        <HiOutlineCheck className="w-4 h-4 text-green-500" />
                        <span className="text-xs text-green-700 font-semibold">{u.satisCount || 0}</span>
                      </div>
                      {/* Üretim */}
                      <div className="flex flex-col items-center">
                        <HiOutlineCog className="w-4 h-4 text-yellow-500" />
                        <span className="text-xs text-yellow-700 font-semibold">{u.uretimCount || 0}</span>
                      </div>
                    </div>
                  </td>
                  {/* Fiyat kolonunu sadeleştir */}
                  <td className="px-3 py-2">
                    <span className="text-green-800">{u.price} ₺</span>
                  </td>
                  <td className="px-3 py-2 font-mono">
                    {u.price ? (Number(u.price) / 40).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' $' : '-'}
                  </td>
                  <td className="px-3 py-2 flex gap-2">
                    <button className="px-2 py-1 rounded bg-blue-100 text-blue-700 hover:bg-blue-200 text-xs font-semibold flex items-center gap-1" onClick={() => handleShowDetail(u)}><HiOutlineEye className="w-4 h-4" /> Detay</button>
                    <button className="px-2 py-1 rounded bg-yellow-100 text-yellow-700 hover:bg-yellow-200 text-xs font-semibold flex items-center gap-1" onClick={() => handleEditProduct(u)}><HiOutlineDocumentText className="w-4 h-4" /> Düzenle</button>
                    <button className="px-2 py-1 rounded bg-red-100 text-red-700 hover:bg-red-200 text-xs font-semibold flex items-center gap-1" onClick={() => handleDelete(u.id)}><HiOutlineTrash className="w-4 h-4" /> Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Detay Modalı */}
      {showDetail && detailProduct && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[80vh] flex flex-col border border-blue-100 animate-fade-in">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-blue-100">
              <div className="text-xl font-bold text-blue-900 flex items-center gap-2">
                <HiOutlineCube className="w-6 h-6 text-blue-700" /> 
                Ürün Detayı
              </div>
              <button 
                onClick={() => setShowDetail(false)}
                className="text-gray-400 hover:text-gray-600 transition"
              >
                <HiOutlineX className="w-6 h-6" />
              </button>
            </div>

            {/* Tabs */}
            <div className="flex gap-1 p-4 pb-0">
              <button 
                className={`px-4 py-2 rounded-t-lg text-sm font-medium transition ${
                  detailTab === 'general' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`} 
                onClick={() => setDetailTab('general')}
              >
                Genel Bilgiler
              </button>
              <button 
                className={`px-4 py-2 rounded-t-lg text-sm font-medium transition ${
                  detailTab === 'pricing' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`} 
                onClick={() => setDetailTab('pricing')}
              >
                Fiyat Bilgileri
              </button>
              <button 
                className={`px-4 py-2 rounded-t-lg text-sm font-medium transition ${
                  detailTab === 'process' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`} 
                onClick={() => setDetailTab('process')}
              >
                Süreç Takibi
              </button>
              <button 
                className={`px-4 py-2 rounded-t-lg text-sm font-medium transition ${
                  detailTab === 'udi' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`} 
                onClick={() => setDetailTab('udi')}
              >
                UDI Kodları
              </button>
              <button 
                className={`px-4 py-2 rounded-t-lg text-sm font-medium transition ${
                  detailTab === 'history' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`} 
                onClick={() => setDetailTab('history')}
              >
                Geçmiş
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6">
              {detailTab === 'general' && (
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Ürün Kodu:</span>
                      <span className="font-mono text-blue-900">{detailProduct.code || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Stok Kodu:</span>
                      <span className="font-mono text-purple-600 font-semibold">{detailProduct.stock_code || '-'}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="font-semibold text-gray-700">DMO Kodu:</span>
                      <span className={`font-mono font-semibold px-2 py-0.5 rounded ${detailProduct.dmoKodu ? 'bg-orange-100 text-orange-800' : 'text-gray-400'}`}>
                        {detailProduct.dmoKodu || '-'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Barkod:</span>
                      <span className="font-mono">{detailProduct.barcode || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Kategori:</span>
                      <span>{detailProduct.kategori || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Marka:</span>
                      <span>{detailProduct.marka || '-'}</span>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Stok:</span>
                      <span>{detailProduct.stock || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Promosyon:</span>
                      <span>{detailProduct.promo ? '✓ Evet' : '✗ Hayır'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Sisteme Eklenme:</span>
                      <span>{detailProduct.created_at ? new Date(detailProduct.created_at).toLocaleDateString('tr-TR') : '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Ölçüler:</span>
                      <span className="text-xs text-right max-w-[200px] truncate" title={detailProduct.measures}>{detailProduct.measures || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">SUT Kütüphanesi:</span>
                      <span className={detailProduct.source_file ? 'text-green-600 font-semibold' : 'text-gray-500'}>
                        {detailProduct.source_file ? '✓ Mevcut' : '✗ Yok'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700">Kaynak Dosya:</span>
                      <span className="text-xs text-gray-500 max-w-32 truncate" title={detailProduct.source_file}>
                        {detailProduct.source_file || '-'}
                      </span>
                    </div>
                  </div>
                  <div className="col-span-2">
                    <div className="font-semibold text-gray-700 mb-2">Ürün Adı:</div>
                    <div className="bg-gray-50 p-3 rounded-lg text-blue-900 font-medium">
                      {detailProduct.name}
                    </div>
                  </div>

                  {/* Ürün Açıklaması */}
                  {detailProduct.description && (
                    <div className="col-span-2 mt-2">
                      <div className="font-semibold text-gray-700 mb-2">Ürün Açıklaması:</div>
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-gray-800 leading-relaxed">
                        {detailProduct.description}
                      </div>
                    </div>
                  )}

                  {/* SUT Kodları ve Açıklamaları */}
                  {detailProduct.sut_codes && (
                    <div className="col-span-2 mt-2">
                      <div className="font-semibold text-gray-700 mb-2">SUT Kodları ve Açıklamaları:</div>
                      <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
                        {/* SUT Kod Butonları */}
                        <div className="flex flex-wrap gap-2 mb-3">
                          {detailProduct.sut_codes.split(',').map(code => code.trim()).filter(Boolean).map(code => {
                            const detail = sutDetails.find(s => s.sut_code === code);
                            return (
                              <button
                                key={code}
                                onClick={() => setSelectedSutCode(code)}
                                className={`px-3 py-1.5 rounded-lg text-xs font-bold transition border ${
                                  selectedSutCode === code 
                                    ? 'bg-indigo-600 text-white border-indigo-600 shadow-md' 
                                    : 'bg-white text-indigo-700 border-indigo-300 hover:bg-indigo-100'
                                }`}
                              >
                                {code}
                                {detail && <span className="ml-1 opacity-75">({Number(detail.price).toLocaleString('tr-TR')} ₺)</span>}
                              </button>
                            );
                          })}
                        </div>

                        {/* Seçili SUT Kodunun Detayları */}
                        {selectedSutCode && (() => {
                          const detail = sutDetails.find(s => s.sut_code === selectedSutCode);
                          if (!detail) return (
                            <div className="text-sm text-gray-500 italic">Bu SUT kodu için açıklama bulunamadı.</div>
                          );
                          return (
                            <div className="space-y-2">
                              <div className="flex items-center gap-3">
                                <span className="bg-indigo-600 text-white px-3 py-1 rounded-md text-sm font-bold">{detail.sut_code}</span>
                                <span className="text-lg font-bold text-green-700">{Number(detail.price).toLocaleString('tr-TR', {minimumFractionDigits: 2})} {detail.currency || 'TL'}</span>
                              </div>
                              {detail.description && (
                                <div className="bg-white rounded-md p-3 border border-indigo-100">
                                  <div className="text-xs font-semibold text-indigo-800 mb-1">Tanım:</div>
                                  <div className="text-sm text-gray-800">{detail.description}</div>
                                </div>
                              )}
                              {detail.aciklama && (
                                <div className="bg-yellow-50 rounded-md p-3 border border-yellow-200">
                                  <div className="text-xs font-semibold text-yellow-800 mb-1">Açıklama / Koşullar:</div>
                                  <div className="text-xs text-gray-700 leading-relaxed">{detail.aciklama}</div>
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    </div>
                  )}

                  {/* DMO Kodu Detay */}
                  {detailProduct.dmoKodu && (
                    <div className="col-span-2">
                      <div className="font-semibold text-gray-700 mb-2">DMO Bilgileri:</div>
                      <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 flex items-center gap-4">
                        <div className="bg-orange-600 text-white px-4 py-2 rounded-lg font-bold text-lg">
                          {detailProduct.dmoKodu}
                        </div>
                        <div className="text-sm text-gray-700">
                          <div className="font-semibold">DMO (Devlet Malzeme Ofisi) Kodu</div>
                          <div className="text-xs text-gray-500">Bu kod ile DMO üzerinden tedarik edilebilir.</div>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Ürün Resmi */}
                  <div className="col-span-2">
                    <div className="font-semibold text-gray-700 mb-2">Ürün Resmi:</div>
                    <div className="flex items-center gap-4">
                      {detailProduct.image_url ? (
                        <div className="relative">
                          <img 
                            src={detailProduct.image_url} 
                            alt={detailProduct.name}
                            className="w-32 h-32 object-cover rounded-lg border-2 border-gray-200"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                          <div className="hidden w-32 h-32 bg-gray-100 rounded-lg border-2 border-gray-200 items-center justify-center">
                            <HiOutlineCube className="w-8 h-8 text-gray-400" />
                          </div>
                        </div>
                      ) : (
                        <div className="w-32 h-32 bg-gray-100 rounded-lg border-2 border-gray-200 flex items-center justify-center">
                          <HiOutlineCube className="w-8 h-8 text-gray-400" />
                        </div>
                      )}
                      
                      <div className="flex flex-col gap-2">
                        <label className={`cursor-pointer px-4 py-2 rounded-lg transition text-sm font-medium text-center ${
                          uploadingImage 
                            ? 'bg-gray-400 text-white cursor-not-allowed' 
                            : 'bg-blue-600 text-white hover:bg-blue-700'
                        }`}>
                          {uploadingImage ? 'Yükleniyor...' : 'Dosyadan Yükle'}
                          <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                handleImageUpload(file, detailProduct.id);
                                e.target.value = '';
                              }
                            }}
                            disabled={uploadingImage}
                          />
                        </label>
                        <button
                          onClick={openMediaLibrary}
                          className="px-4 py-2 rounded-lg transition text-sm font-medium text-center bg-purple-600 text-white hover:bg-purple-700"
                        >
                          Kütüphaneden Seç
                        </button>
                        {detailProduct.image_url && (
                          <button
                            onClick={() => {
                              const updatedProducts = urunler.map(product => {
                                if (product.id === detailProduct.id) {
                                  return { ...product, image_url: null };
                                }
                                return product;
                              });
                              setUrunler(updatedProducts);
                              // Backend'de resmi kaldır
                              fetch(`/api/products/${detailProduct.id}`, {
                                method: 'PUT',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ image_url: null })
                              });
                            }}
                            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition text-sm font-medium"
                          >
                            Resmi Kaldır
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  {/* Etiket Yönetimi */}
                  <div className="col-span-2">
                    <div className="font-semibold text-gray-700 mb-2">Etiketler:</div>
                    <div className="flex items-center gap-3">
                      <input
                        type="text"
                        value={editingTags}
                        onChange={(e) => setEditingTags(e.target.value)}
                        placeholder="Etiketleri virgülle ayırarak yazın..."
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                      />
                      <button
                        onClick={() => {
                          handleUpdateTags(detailProduct.id, editingTags);
                          setEditingTags('');
                        }}
                        className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition text-sm font-medium"
                      >
                        Kaydet
                      </button>
                      <button
                        onClick={() => {
                          handleGetTagSuggestions(detailProduct.name, detailProduct.kategori);
                          setShowTagWizard(true);
                        }}
                        className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition text-sm font-medium"
                        title="AI Etiket Önerisi"
                      >
                        🪄 Sihirbaz
                      </button>
                    </div>
                    
                    {/* Etiket Önerileri */}
                    {showTagWizard && tagSuggestions.length > 0 && (
                      <div className="mt-3 p-3 bg-purple-50 border border-purple-200 rounded-lg">
                        <div className="text-sm font-semibold text-purple-800 mb-2">AI Etiket Önerileri:</div>
                        <div className="flex flex-wrap gap-1 mb-3">
                          {tagSuggestions.map((tag, index) => (
                            <span
                              key={index}
                              className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs"
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleApplyTagSuggestions(detailProduct.id)}
                            className="bg-purple-600 text-white px-3 py-1 rounded text-sm hover:bg-purple-700"
                          >
                            Önerileri Uygula
                          </button>
                          <button
                            onClick={() => {
                              setShowTagWizard(false);
                              setTagSuggestions([]);
                            }}
                            className="bg-gray-500 text-white px-3 py-1 rounded text-sm hover:bg-gray-600"
                          >
                            Kapat
                          </button>
                        </div>
                      </div>
                    )}
                    
                    {detailProduct.tags && (
                      <div className="mt-2">
                        <div className="text-sm text-gray-600 mb-1">Mevcut Etiketler:</div>
                        <div className="flex flex-wrap gap-1">
                          {detailProduct.tags.split(',').map((tag, index) => (
                            <span
                              key={index}
                              className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs"
                            >
                              {tag.trim()}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {detailTab === 'pricing' && (
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-green-50 p-4 rounded-lg">
                      <div className="text-sm font-semibold text-green-800 mb-1">Birim Fiyatı (TL)</div>
                      <div className="text-2xl font-bold text-green-700">{detailProduct.price || '0'} ₺</div>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <div className="text-sm font-semibold text-blue-800 mb-1">İhracat Fiyatı (USD)</div>
                      <div className="text-2xl font-bold text-blue-700">
                        {detailProduct.price ? (Number(detailProduct.price) / 40).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0'} $
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <div className="text-sm font-semibold text-gray-700 mb-2">Fiyat Geçmişi</div>
                    {/* Fiyat değişim geçmişi */}
                    {detailProduct.log && detailProduct.log.filter(l => l.action && l.action.toLowerCase && l.action.toLowerCase().includes('fiyat')).length > 0 ? (
                      <ul className="text-xs text-gray-700 space-y-1">
                        {detailProduct.log.filter(l => l.action && l.action.toLowerCase && l.action.toLowerCase().includes('fiyat')).map((l, i) => (
                          <li key={i} className="flex justify-between items-center">
                            <span>{l.action}</span>
                            <span className="text-gray-400">{l.date}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="text-xs text-gray-400">Fiyat değişim kaydı bulunamadı.</div>
                    )}
                  </div>
                </div>
              )}

              {detailTab === 'process' && (
                <div className="space-y-4">
                  <div className="grid grid-cols-3 gap-4">
                    <div className="bg-blue-50 p-4 rounded-lg text-center">
                      <HiOutlineClipboardList className="w-8 h-8 text-blue-500 mx-auto mb-2" />
                      <div className="text-2xl font-bold text-blue-700">{detailProduct.proformaCount || 0}</div>
                      <div className="text-sm text-blue-600">Proforma</div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg text-center">
                      <HiOutlineCheck className="w-8 h-8 text-green-500 mx-auto mb-2" />
                      <div className="text-2xl font-bold text-green-700">{detailProduct.satisCount || 0}</div>
                      <div className="text-sm text-green-600">Satış</div>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-lg text-center">
                      <HiOutlineCog className="w-8 h-8 text-yellow-500 mx-auto mb-2" />
                      <div className="text-2xl font-bold text-yellow-700">{detailProduct.uretimCount || 0}</div>
                      <div className="text-sm text-yellow-600">Üretim</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <div className="text-sm font-semibold text-gray-700 mb-2">Süreç Detayları</div>
                    {/* Süreç detayları geçmişi */}
                    {detailProduct.log && detailProduct.log.filter(l => l.action && l.action.toLowerCase && (
                      l.action.toLowerCase().includes('proforma') ||
                      l.action.toLowerCase().includes('satış') ||
                      l.action.toLowerCase().includes('üretim')
                    )).length > 0 ? (
                      <ul className="text-xs text-gray-700 space-y-1">
                        {detailProduct.log.filter(l => l.action && l.action.toLowerCase && (
                          l.action.toLowerCase().includes('proforma') ||
                          l.action.toLowerCase().includes('satış') ||
                          l.action.toLowerCase().includes('üretim')
                        )).map((l, i) => (
                          <li key={i} className="flex justify-between items-center">
                            <span>{l.action}</span>
                            <span className="text-gray-400">{l.date}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="text-xs text-gray-400">Süreç ile ilgili geçmiş kaydı bulunamadı.</div>
                    )}
                  </div>
                </div>
              )}

              {detailTab === 'udi' && (
                <div className="space-y-4">
                  <div className="text-sm font-semibold text-blue-900 mb-2">Bu ürün için oluşturulan UDI Kodları</div>
                  {getProductUDIs(detailProduct).length === 0 ? (
                    <div className="text-center py-8">
                      <HiOutlineDocumentText className="w-12 h-12 text-gray-300 mx-auto mb-2" />
                      <div className="text-gray-400">Henüz bu ürün için UDI kodu oluşturulmamış.</div>
                    </div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-xs">
                        <thead>
                          <tr className="bg-blue-50 text-blue-900">
                            <th className="px-3 py-2 text-left">UDI Kodu</th>
                            <th className="px-3 py-2 text-left">Teklif No</th>
                            <th className="px-3 py-2 text-left">Tarih</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getProductUDIs(detailProduct).map((u, i) => (
                            <tr key={i} className="border-b border-gray-100">
                              <td className="px-3 py-2 font-mono break-all">{u.udi}</td>
                              <td className="px-3 py-2">{u.offerNo}</td>
                              <td className="px-3 py-2">{u.date}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {detailTab === 'history' && (
                <div className="space-y-4">
                  <div className="text-sm font-semibold text-blue-900 mb-2">Ürün Geçmişi</div>
                  {detailProduct.log && detailProduct.log.length > 0 ? (
                    <div className="space-y-2">
                      {detailProduct.log.map((log, index) => (
                        <div key={index} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                          <div className="flex-1">
                            <div className="text-sm font-medium text-gray-900">{log.action}</div>
                            <div className="text-xs text-gray-500">{log.date}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8">
                      <HiOutlineCalendar className="w-12 h-12 text-gray-300 mx-auto mb-2" />
                      <div className="text-gray-400">Henüz geçmiş kaydı bulunmuyor.</div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Toplu Yükleme Modalı */}
      {showImportModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md flex flex-col gap-4 border border-blue-100">
            <div className="text-xl font-bold text-blue-900 text-center mb-2">Toplu Ürün Yükleme</div>
            {importStep === 0 && (
              <>
                <div className="text-sm text-gray-600 text-center mb-4">
                  Excel dosyası seçin (.xlsx, .xls, .csv)
                </div>
                <input
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  onChange={handleImportFileChange}
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
                
                {/* Excel Önizleme */}
                {showPreview && previewData && (
                  <div className="mt-4 p-4 bg-gray-50 border rounded-lg max-h-60 overflow-y-auto">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-sm font-semibold text-gray-800">Excel Önizleme (İlk 10 Satır)</h3>
                      <button 
                        className="text-xs text-gray-500 hover:text-gray-700"
                        onClick={() => setShowPreview(false)}
                      >
                        ✕ Kapat
                      </button>
                    </div>
                    
                    <div className="overflow-x-auto">
                      <table className="min-w-full border border-gray-200 text-xs">
                        <thead>
                          <tr className="bg-gray-100">
                            {previewData.length > 0 && Object.keys(previewData[0]).map((header, index) => (
                              <th key={index} className="border border-gray-200 px-2 py-1 text-left font-semibold text-gray-700">
                                {header}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {previewData.map((row, rowIndex) => (
                            <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                              {Object.keys(previewData[0]).map((header, colIndex) => (
                                <td key={colIndex} className="border border-gray-200 px-2 py-1 text-gray-700">
                                  {row[header] || '-'}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    
                    <div className="mt-2 text-xs text-gray-600">
                      <p>• Toplam {previewData.length} satır önizleniyor</p>
                      <p>• Tüm veriler yüklendiğinde tam liste işlenecek</p>
                    </div>
                  </div>
                )}
                
                <div className="flex gap-2">
                  <button
                    className="flex-1 px-4 py-2 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
                    onClick={handleImportStart}
                    disabled={!importFile}
                  >
                    Yükle
                  </button>
                  <button
                    className="px-4 py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 transition"
                    onClick={async () => {
                      try {
                        console.log('Test: Fetching fields...');
                        const response = await fetch('/api/products/fields');
                        const result = await response.json();
                        console.log('Test: Fields result:', result);
                        alert(`Alanlar yüklendi: ${result.fields.length} alan`);
                      } catch (error) {
                        console.error('Test error:', error);
                        alert('Hata: ' + error.message);
                      }
                    }}
                  >
                    Test API
                  </button>
                  <button
                    className="flex-1 px-4 py-2 rounded bg-gray-200 text-blue-900 font-semibold hover:bg-gray-300 transition"
                    onClick={() => {
                      setShowImportModal(false);
                      setImportFile(null);
                      setPreviewData(null);
                      setShowPreview(false);
                      setImportError("");
                      setImportResult(null);
                    }}
                  >
                    İptal
                  </button>
                </div>
              </>
            )}
            {importStep === 1 && (
              <div className="text-center">
                <div className="text-lg font-semibold text-blue-900 mb-2">Yükleniyor...</div>
                <div className="text-sm text-gray-600">Lütfen bekleyin</div>
              </div>
            )}
            {importStep === 2 && (
              <>
                <div className="text-center">
                  <div className="text-lg font-semibold text-green-600 mb-2">✓ İşlem Tamamlandı!</div>
                  <div className="text-sm text-gray-600 mb-4">
                    {importMessage}
                  </div>
                  <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-sm text-green-700">
                    <div className="space-y-1">
                      <div>📥 Yeni eklenen: {importResult?.inserted || 0} ürün</div>
                      <div>🔄 Güncellenen: {importResult?.updated || 0} ürün</div>
                      <div>⏭️ Atlanan: {importResult?.skipped || 0} ürün</div>
                      <div className="font-medium">📊 Toplam: {importResult?.total || 0} ürün işlendi</div>
                    </div>
                  </div>
                </div>
                <button
                  className="px-4 py-2 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
                  onClick={() => setShowImportModal(false)}
                >
                  Tamam
                </button>
              </>
            )}
            {importError && (
              <div className="text-red-600 text-sm text-center">{importError}</div>
            )}
          </div>
        </div>
      )}

      {/* Kolon Eşleştirme Modalı */}
      {showColumnMapping && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="text-xl font-bold text-blue-900 text-center mb-6">Excel Kolon Eşleştirme</div>
            
            <div className="mb-6 p-4 bg-blue-50 rounded-lg">
              <div className="text-sm text-blue-800">
                <p className="font-semibold mb-2">📋 Nasıl Çalışır:</p>
                <ul className="space-y-1 text-xs">
                  <li>• Sol tarafta veritabanı alanları listelenir</li>
                  <li>• Sağ tarafta Excel'deki kolonları seçebilirsiniz</li>
                  <li>• <span className="font-semibold text-red-600">Kırmızı</span> alanlar zorunludur</li>
                  <li>• Eşleştirme yapmadan import işlemi başlamaz</li>
                </ul>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Veritabanı Alanları */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">📊 Veritabanı Alanları ({availableFields.length})</h3>
                <div className="space-y-3">
                  {availableFields.length === 0 && (
                    <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700">
                      ⚠️ Alanlar yüklenemedi. Lütfen sayfayı yenileyin.
                    </div>
                  )}
                  {availableFields.map((field) => (
                    <div key={field.key} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center gap-2">
                        <span className={`text-sm font-medium ${field.required ? 'text-red-600' : 'text-gray-700'}`}>
                          {field.label}
                        </span>
                        {field.required && <span className="text-red-500 text-xs">*</span>}
                      </div>
                      <select
                        className="text-sm border border-gray-300 rounded px-2 py-1 bg-white"
                        value={columnMapping[field.key] || ''}
                        onChange={(e) => setColumnMapping(prev => ({
                          ...prev,
                          [field.key]: e.target.value
                        }))}
                      >
                        <option value="">Seçiniz</option>
                        {excelColumns.map((col) => (
                          <option key={col} value={col}>{col}</option>
                        ))}
                      </select>
                    </div>
                  ))}
                </div>
              </div>

              {/* Excel Kolonları */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">📄 Excel Kolonları</h3>
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="text-sm text-gray-600 mb-3">Dosyada bulunan kolonlar:</div>
                  <div className="grid grid-cols-2 gap-2">
                    {excelColumns.map((col) => (
                      <div key={col} className="bg-white px-3 py-2 rounded border text-sm font-mono">
                        {col}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                className="flex-1 px-4 py-2 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
                onClick={() => {
                  setShowColumnMapping(false);
                  handleImportStart();
                }}
                disabled={!Object.keys(columnMapping).some(key => columnMapping[key])}
              >
                Eşleştirmeyi Tamamla ve Yükle
              </button>
              <button
                className="flex-1 px-4 py-2 rounded bg-gray-200 text-blue-900 font-semibold hover:bg-gray-300 transition"
                onClick={() => setShowColumnMapping(false)}
              >
                İptal
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Düzenleme Modalı */}
      {showEditModal && editingProduct && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-blue-100">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-blue-100">
              <div className="text-xl font-bold text-blue-900 flex items-center gap-2">
                <HiOutlineDocumentText className="w-6 h-6 text-blue-700" /> 
                Ürün Düzenle
              </div>
              <button 
                onClick={() => {
                  setShowEditModal(false);
                  setEditingProduct(null);
                  setEditForm({});
                }}
                className="text-gray-400 hover:text-gray-600 transition"
              >
                <HiOutlineX className="w-6 h-6" />
              </button>
            </div>

            {/* Form */}
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Ürün Adı */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Ürün Adı *
                  </label>
                  <input
                    type="text"
                    value={editForm.name || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, name: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Ürün adını girin"
                  />
                </div>

                {/* SUT Kodu */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    SUT Kodu
                  </label>
                  <input
                    type="text"
                    value={editForm.code || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, code: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="SUT kodunu girin"
                  />
                </div>

                {/* DMO Kodu */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    DMO Kodu
                  </label>
                  <input
                    type="text"
                    value={editForm.dmoKodu || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, dmoKodu: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="DMO kodunu girin"
                  />
                </div>

                {/* Barkod */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Barkod
                  </label>
                  <input
                    type="text"
                    value={editForm.barcode || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, barcode: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Barkod girin"
                  />
                </div>

                {/* Lot */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Lot
                  </label>
                  <input
                    type="text"
                    value={editForm.lot || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, lot: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Lot numarası"
                  />
                </div>

                {/* Stok */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Stok
                  </label>
                  <input
                    type="text"
                    value={editForm.stock || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, stock: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Stok miktarı"
                  />
                </div>

                {/* Fiyat */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Fiyat (₺)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={editForm.price || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, price: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="0.00"
                  />
                </div>

                {/* Üretim Tarihi */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Üretim Tarihi
                  </label>
                  <input
                    type="date"
                    value={editForm.uretimTarihi || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, uretimTarihi: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>

                {/* Promosyon */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Promosyon
                  </label>
                  <input
                    type="text"
                    value={editForm.skt || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, skt: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Promosyon bilgisi"
                  />
                </div>

                {/* Kategori */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Kategori
                  </label>
                  <input
                    type="text"
                    value={editForm.kategori || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, kategori: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Kategori"
                  />
                </div>

                {/* Etiketler */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Etiketler
                  </label>
                  <input
                    type="text"
                    value={editForm.tags || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, tags: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Etiketleri virgülle ayırarak girin"
                  />
                </div>

                {/* Açıklama */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Açıklama
                  </label>
                  <textarea
                    value={editForm.description || ''}
                    onChange={(e) => setEditForm(prev => ({ ...prev, description: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    rows="3"
                    placeholder="Ürün açıklaması"
                  />
                </div>
              </div>

              {/* Butonlar */}
              <div className="flex gap-3 mt-6">
                <button
                  onClick={handleSaveEdit}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
                >
                  Kaydet
                </button>
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingProduct(null);
                    setEditForm({});
                  }}
                  className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 font-semibold rounded-lg hover:bg-gray-300 transition"
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Medya Kütüphanesi Modalı */}
      {showMediaLibrary && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[85vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-5 border-b border-gray-200">
              <div>
                <h2 className="text-xl font-bold text-gray-900">Medya Kütüphanesi</h2>
                <p className="text-sm text-gray-500 mt-0.5">{mediaFiles.length} dosya · /urunler/ dizini</p>
              </div>
              <button onClick={() => setShowMediaLibrary(false)} className="text-gray-400 hover:text-gray-600 transition text-2xl font-bold">&times;</button>
            </div>

            {/* Arama */}
            <div className="px-5 py-3 border-b border-gray-100">
              <input
                type="text"
                placeholder="Dosya adına göre ara..."
                value={mediaSearch}
                onChange={e => setMediaSearch(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-400 focus:border-purple-400 text-sm"
              />
            </div>

            {/* İçerik */}
            <div className="flex-1 overflow-y-auto p-5">
              {mediaLoading ? (
                <div className="flex flex-col items-center justify-center py-16">
                  <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600 mb-3"></div>
                  <p className="text-gray-500">Yükleniyor...</p>
                </div>
              ) : (
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3">
                  {mediaFiles
                    .filter(f => !mediaSearch || f.name.toLowerCase().includes(mediaSearch.toLowerCase()))
                    .map(file => (
                      <button
                        key={file.name}
                        onClick={() => handleSelectFromLibrary(file.url)}
                        className="group flex flex-col items-center border-2 border-gray-200 rounded-xl p-2 hover:border-purple-500 hover:shadow-lg transition-all bg-white"
                      >
                        <div className="w-full aspect-square bg-gray-50 rounded-lg overflow-hidden flex items-center justify-center mb-2">
                          <img
                            src={file.url}
                            alt={file.name}
                            className="object-contain w-full h-full group-hover:scale-105 transition-transform"
                            onError={(e) => { e.target.src = '/urunler/300x300.png'; }}
                          />
                        </div>
                        <span className="text-xs text-gray-600 truncate w-full text-center group-hover:text-purple-700" title={file.name}>
                          {file.name.length > 20 ? file.name.substring(0, 18) + '...' : file.name}
                        </span>
                        <span className="text-xs text-gray-400">{(file.size / 1024).toFixed(0)} KB</span>
                      </button>
                    ))
                  }
                  {mediaFiles.filter(f => !mediaSearch || f.name.toLowerCase().includes(mediaSearch.toLowerCase())).length === 0 && (
                    <div className="col-span-full text-center py-12 text-gray-400">
                      {mediaSearch ? 'Aramayla eşleşen dosya bulunamadı.' : 'Kütüphanede resim bulunamadı.'}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between p-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
              <span className="text-xs text-gray-500">Bir resme tıklayarak ürüne atayabilirsiniz</span>
              <button
                onClick={() => setShowMediaLibrary(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition text-sm font-medium"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 